// Google Calendar Service - Conexión OAuth y sincronización
import { api } from './api';

export interface GoogleCalendarStatus {
  connected: boolean;
  google_email?: string;
  scopes?: string;
  token_expires_at?: string;
  is_revoked?: boolean;
}

export interface GoogleCalendarConnectUrl {
  url: string;
  state: string;
}

export interface GoogleCalendarEvent {
  id: string;
  summary: string | null;
  start: string;
  end: string;
  description: string | null;
  location: string | null;
  html_link: string | null;
  is_all_day: boolean;
  status: string;
}

export interface GoogleCalendarEventsResponse {
  items: GoogleCalendarEvent[];
  connected: boolean;
}

export interface BusyPeriod {
  start: string;
  end: string;
}

export interface AvailabilityResponse {
  busy_periods: BusyPeriod[];
  is_available: boolean;
}

export const googleCalendarService = {
  /**
   * Obtener URL de autorización OAuth de Google Calendar
   */
  async getConnectUrl(): Promise<GoogleCalendarConnectUrl> {
    const { data } = await api.get<GoogleCalendarConnectUrl>('/auth/google/calendar/connect/url');
    return data;
  },

  /**
   * Intercambiar código OAuth por tokens (después del redirect de Google)
   */
  async connect(code: string, state?: string): Promise<{ message: string }> {
    const { data } = await api.post<{ message: string }>('/auth/google/calendar/connect', {
      code,
      state,
    });
    return data;
  },

  /**
   * Desconectar Google Calendar (revocar tokens)
   */
  async disconnect(): Promise<{ message: string }> {
    const { data } = await api.post<{ message: string }>('/auth/google/calendar/disconnect');
    return data;
  },

  /**
   * Obtener estado de conexión de Google Calendar
   */
  async getStatus(): Promise<GoogleCalendarStatus> {
    const { data } = await api.get<GoogleCalendarStatus>('/auth/google/calendar/status');
    return data;
  },

  async getEvents(params: {
    start_date: string;
    end_date: string;
  }): Promise<GoogleCalendarEventsResponse> {
    const { data } = await api.get<GoogleCalendarEventsResponse>('/crm/google-calendar/events', {
      params,
    });
    return data;
  },

  async checkAvailability(params: {
    start: string;
    end: string;
    calendar_id?: string;
  }): Promise<AvailabilityResponse> {
    const { data } = await api.post<AvailabilityResponse>(
      '/crm/google-calendar/availability',
      params,
    );
    return data;
  },
};
